import { tokens } from './tokens';

import { PaletteColor } from '@material-ui/core/styles/createPalette';
import { CSSProperties } from '@material-ui/styles';

export const verticalCenter: CSSProperties = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
};

export const horizontalCenter: CSSProperties = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
};

export const absoluteCenter: CSSProperties = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export const scrollbar = (color: PaletteColor): any => ({
  '-webkit-overflow-scrolling': 'touch',

  '@media (pointer: fine)': {
    /* width */
    '&::-webkit-scrollbar': {
      width: 6,
    },

    /* Track */
    '&::-webkit-scrollbar-track': {
      borderRadius: 10,
      backgroundColor: tokens.colors.bg,
    },

    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      padding: 5,
      background: color.main,
      borderRadius: 10,
    },

    /* Handle on hover */
    '&::-webkit-scrollbar-thumb:hover': {
      background: color.dark,
    },
  },
});
